import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import {
  DoneIcon,
  NotRequiredIcon,
  WarningIcon,
} from '../../../../layouts/dashboard/nav/IconButton';
import { InspectionStatusList } from '../../../../utils/enum';

export const statusTypes = _.keyBy(
  [
    {
      id: InspectionStatusList.INSPECTION_NEED,
      txtColor: '#D22259',
      bgColor: '#FFECF1',
      label: '점검전',
      maxWidth: '86px',
      icon: <WarningIcon />,
    },
    {
      id: InspectionStatusList.INSPECTED,
      txtColor: '#25B5BE',
      bgColor: '#EDFFFB',
      label: '점검완료',
      maxWidth: '100px',
      icon: <DoneIcon />,
    },
    {
      id: InspectionStatusList.INSPECTION_NOT_REQUIRED,
      txtColor: '#48464C',
      bgColor: '#EFEFEF',
      label: '일반시설물',
      maxWidth: '100px',
      icon: <NotRequiredIcon />,
    },
  ],
  'id',
);
export function InspectionStatusChips({ status }: any) {
  const label = statusTypes[status];

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        color: label?.txtColor,
        background: label?.bgColor,
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: label?.maxWidth,
        borderRadius: '30px',
        py: 0.8,
        mb: 1,
      }}
    >
      {label?.icon}
      <Typography pt="2px" sx={{ fontWeight: 700, fontSize: '12px' }}>
        {_.get(label, 'label', '-')}
      </Typography>
    </Stack>
  );
}
